import { Map } from "ol";

export const drawCanvasMap = (shadowMap: Map): HTMLCanvasElement => {
    const canvas = document.createElement("canvas");
    const size = shadowMap.getSize();
    canvas.width = size[0];
    canvas.height = size[1];
    const ctx = canvas.getContext("2d");

    Array.prototype.forEach.call(document.querySelectorAll(".ol-layer canvas"), (canvas) => {
        if (canvas.width > 0) {
            const opacity = canvas.parentNode.style.opacity;
            ctx.globalAlpha = opacity === "" ? 1 : Number(opacity);
            const transform = canvas.style.transform;
            // Get the transform parameters from the style's transform matrix
            const matrix = transform
                .match(/^matrix\(([^\(]*)\)$/)[1]
                .split(",")
                .map(Number);
            // Apply the transform to the export map context
            CanvasRenderingContext2D.prototype.setTransform.apply(ctx, matrix);
            ctx.drawImage(canvas, 0, 0);
        }
    });

    return canvas;
};

export const drawCanvasScale = (mapCanvas: HTMLCanvasElement): void => {
    const ctx = mapCanvas.getContext("2d");
    if (!ctx) return;

    const scaleContainerStyles = window.getComputedStyle(
        document.getElementsByClassName("ol-scale-line scale-container ol-control ol-unselectable")[0]
    );
    const scaleLineStyles = window.getComputedStyle(
        document.getElementsByClassName("ol-scale-line scale-container ol-control-inner")[0]
    );

    const barWidth = parseInt(scaleLineStyles.width);
    const barHeight = parseInt(scaleLineStyles.height);
    const margin = parseInt(scaleContainerStyles.marginBottom);
    const bottom = mapCanvas.height - margin;

    // Draw scale bar
    ctx.beginPath();
    ctx.rect(margin, bottom - barHeight, barWidth, barHeight);
    ctx.fillStyle = scaleLineStyles.backgroundColor;
    ctx.fill();

    // Draw scale border
    ctx.beginPath();
    ctx.moveTo(margin, bottom - barHeight);
    ctx.lineTo(margin, bottom);
    ctx.lineTo(margin + barWidth, bottom);
    ctx.lineTo(margin + barWidth, bottom - barHeight);
    ctx.lineWidth = 2;
    ctx.fillStyle = scaleLineStyles.borderColor;
    ctx.stroke();

    // Draw scale text
    const text = document.querySelector<HTMLElement>(".scale-container.ol-control-inner").textContent;
    ctx.beginPath();
    ctx.font = scaleLineStyles.font;
    ctx.fillStyle = scaleLineStyles.color;
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.fillText(text, margin + barWidth / 2, bottom);
};

export const drawCanvasAttribution = (mapCanvas: HTMLCanvasElement): void => {
    const ctx = mapCanvas.getContext("2d");
    if (!ctx) return;

    const attributions = [];
    const attributionNode = document.getElementsByClassName(
        "ol-attribution ol-unselectable ol-control ol-uncollapsible"
    )[0];

    const list = attributionNode.getElementsByTagName("li");
    const length = document.getElementsByTagName("li").length;
    for (let i = 0; i <= length; ++i) {
        list[i] && attributions.push(list[i].innerText);
    }
    const text = attributions.length ? attributions.reverse().join(", ") : "";

    const containerStyles = window.getComputedStyle(
        document.getElementsByClassName("ol-attribution ol-unselectable ol-control ol-uncollapsible")[0]
    );

    const barWidth = parseInt(containerStyles.width);
    const barHeight = parseInt(containerStyles.height);
    const bottom = mapCanvas.height;
    const right = mapCanvas.width;

    // Draw attribution bar
    ctx.beginPath();
    ctx.rect(right - barWidth, bottom - barHeight, barWidth, barHeight);
    ctx.fillStyle = containerStyles.backgroundColor;
    ctx.fill();

    // Draw attribution text
    ctx.beginPath();
    ctx.font = containerStyles.font;
    ctx.fillStyle = containerStyles.color;
    ctx.textAlign = "center";
    ctx.textBaseline = "bottom";
    ctx.fillText("© " + text, right - barWidth / 2, bottom);
};
